import React from 'react'
import * as  C from "../componentsM/index"

const LanguageAcquisition = () => {
    return (
        <>

            <C.Hero title={"GROUP 2: LANGUAGE ACQUISITION"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>These are courses designed for students who have no previous experience of and are interested in learning a new foreign language.  Students gain the necessary skills and intercultural understanding to enable them to communicate successfully in an environment where the language studied is spoken.</p>


                    <p>Please note that Language ab initio courses are only offered at the SL level.</p>

                    <p>Subjects currently offered:</p>

                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>English B:</h1>

                    <p>English is available at the intermediate level for those students who are learning English as a second language. In this subject, students should be able to interact with others with a fair level of fluency and vocabulary.</p>


                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>French B:</h1>

                    <p>For those students with prior experience with the language, French B is offered to further develop writing and conversational skills. In this subject, students should be able to interact with others with a fair level of fluency and vocabulary.</p>


                    
                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>French ab initio (SL) and Arabic ab initio (SL):</h1>


                    <p>In both subjects, students should be able to respond and interact appropriately in a defined range of everyday situations through the development of receptive, productive and interactive skills. Both subjects share the three basic themes of Individual and Society, Leisure and Work and Urban and Rural environment.</p>



                </div>
            </section>

        </>

    )
}

export default LanguageAcquisition